import { useEffect, useState } from "react";
import { PageHero } from "./MarketingLayout";
import EnquiryForm from "@/components/EnquiryForm";
import { endpoints } from "@/lib/api";

const tierColors = { Platinum: "#e5e4e2", Gold: "#ffd600", Silver: "#8a8d91" };

export default function Sponsors() {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => { endpoints.sponsors().then(setSponsors).catch(() => {}); }, []);
  const tiers = ["Platinum", "Gold", "Silver"];

  return (
    <div>
      <PageHero eyebrow="Partner with us" title="Sponsors"
        subtitle="Align your brand with Perth's premiere custom car culture show. Tiered packages built to put you in front of a hungry, engaged audience." />
      <section className="max-w-7xl mx-auto px-6 pb-16">
        {tiers.map((tier) => (
          <div key={tier} className="mb-10">
            <div className="font-heading uppercase tracking-widest text-sm mb-4" style={{ color: tierColors[tier] }}>{tier} Partners</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {sponsors.filter((s) => s.tier === tier).map((s) => (
                <div key={s.id} className="border border-white/10 bg-[#121212] px-6 py-8 grid place-items-center card-hover">
                  <span className="font-display text-2xl text-white/85 uppercase text-center">{s.name}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
      <section className="max-w-3xl mx-auto px-6 pb-24">
        <h2 className="font-display text-4xl sm:text-6xl uppercase text-white mb-6">Become a sponsor</h2>
        <EnquiryForm testid="sponsor-form" endpoint="/sponsor-enquiry" successMsg="Sponsor enquiry sent" fields={[
          { name: "name", label: "Contact name", required: true },
          { name: "email", label: "Email", type: "email", required: true },
          { name: "company", label: "Company", required: true },
          { name: "phone", label: "Phone" },
          { name: "tier", label: "Interested tier", type: "select", options: ["Platinum", "Gold", "Silver", "Custom"] },
          { name: "message", label: "What are you hoping to achieve?", type: "textarea" },
        ]} />
      </section>
    </div>
  );
}
